module.exports = __webpack_public_path__ + "src/assets/img/share/b1b450aa6506d6615d2c65815c5d747b.png";